[
  {
    "restaurantId": "demo-burger-house",
    "images": [
      "/reference-images/demo-burger-house/sign-main.svg",
      "/reference-images/demo-burger-house/sign-night.svg"
    ]
  },
  {
    "restaurantId": "demo-cedar-kitchen",
    "images": [
      "/reference-images/demo-cedar-kitchen/sign-main.svg"
    ]
  }
]
